import ApiClient from "../ApiClient";

const SubscriptionService = {

  async getPricingPlan() {
    const resp = await ApiClient.get(`/Subscription/pricing-plans`);
    return resp;
  },

  async getPricingPlanByProduct(productCode) {
    const resp = await ApiClient.get(`/Subscription/pricing-plans/${productCode}`);
    return resp;
  },
  
};

export default SubscriptionService;
